
export const MOBILE_WIDTH = 599;